import RouteErrorPage from "../RouteErrorPage";
import AppRoutes from "./AppRoutes";

// The router catches errors thrown by pages itself, so it needs its own error page; the
// ErrorBoundary in App.js only sees errors from outside the router
const routes = [
  { path: "*", element: <AppRoutes />, errorElement: <RouteErrorPage /> },
];

export default routes;
